import React, { useState } from 'react';
import { Layout, Menu, Button, Space, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSelector from '../LanguageSelector';

const { Header } = Layout;

const PortalHeader: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const menuItems = [
    { key: '/', label: t('portal.nav.home') },
    { key: '/features', label: t('portal.nav.features') },
    { key: '/pricing', label: t('portal.nav.pricing') },
    { key: '/docs', label: t('portal.nav.docs', 'Docs') },
    { key: '/mcp', label: t('portal.nav.mcp', 'MCP') },
    { key: '/news', label: t('portal.nav.news', 'News') },
    { key: '/contact', label: t('portal.nav.contact') },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <Header className="portal-header">
        <Link to="/" style={{ display: 'flex', alignItems: 'center', marginRight: 24, textDecoration: 'none', flexShrink: 0 }}>
          <span style={{
            fontSize: 22,
            fontWeight: 700,
            color: '#fff',
            letterSpacing: '-0.03em',
          }}>
            Pitto
          </span>
          <span style={{
            fontSize: 10,
            fontFamily: 'var(--portal-font-mono)',
            color: 'var(--portal-accent)',
            marginLeft: 8,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
          }}>
            AI
          </span>
        </Link>

        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          className="portal-desktop-menu"
          style={{ border: 'none', background: 'transparent', flex: 1, minWidth: 0, display: 'none' }}
        />

        <Space className="portal-desktop-actions" style={{ display: 'none', flexShrink: 0 }}>
          <LanguageSelector size="small" />
          {user ? (
            <Button className="portal-btn-primary" onClick={() => navigate('/dashboard')}>
              {t('portal.nav.goToDashboard')}
            </Button>
          ) : (
            <>
              <Button className="portal-btn-secondary" onClick={() => navigate('/login')}>
                {t('auth.login')}
              </Button>
              <Button className="portal-btn-primary" onClick={() => navigate('/register')}>
                {t('portal.nav.getStartedFree')}
              </Button>
            </>
          )}
        </Space>

        <Button
          type="text"
          icon={<MenuOutlined style={{ color: '#fff' }} />}
          onClick={() => setMobileMenuOpen(true)}
          className="portal-mobile-menu-button"
          style={{ display: 'none' }}
        />

        <Drawer
          title={<span style={{ fontWeight: 700 }}>Pitto</span>}
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={280}
        >
          <Menu
            mode="vertical"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            style={{ border: 'none' }}
          />
          <div style={{ padding: '16px 0', borderTop: '1px solid #f0f0f0', marginTop: 16 }}>
            <LanguageSelector size="small" style={{ marginBottom: 16 }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {user ? (
                <Button type="primary" block onClick={() => { navigate('/dashboard'); setMobileMenuOpen(false); }}>
                  {t('portal.nav.goToDashboard')}
                </Button>
              ) : (
                <>
                  <Button block onClick={() => { navigate('/login'); setMobileMenuOpen(false); }}>
                    {t('auth.login')}
                  </Button>
                  <Button type="primary" block onClick={() => { navigate('/register'); setMobileMenuOpen(false); }}>
                    {t('portal.nav.getStartedFree')}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Drawer>
      </Header>
      <div className="portal-header-spacer" />
    </>
  );
};

export default PortalHeader;
